import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CustomInputFieldWithModal from '../CustomInputFieldWithModal';

const Withdraw = forwardRef((props, ref) => {
  const { data, versions } = props;
  const [withdrawals, setWithdrawals] = useState([]);
  const START_AGE = data?.age || 1;
  const LIMIT = 100;
  useEffect(() => {
    const withdrawlsToEdit = versions?.[0]?.illustrationData?.withDrawls || [];
    const length = withdrawlsToEdit.length;
    const lastYear = withdrawlsToEdit[length - 1];
    const loopTo = +lastYear?.Yr;
    const withdrawlsToRender = [];
    for (let i = 0; i < loopTo; i++) {
      for (let j = 0; j < length; j++) {
        if (+withdrawlsToEdit[j]?.Yr !== i + 1) {
          withdrawlsToRender[i] = null;
        } else {
          withdrawlsToRender[i] = withdrawlsToEdit[j];
          break;
        }
      }
    }
    setWithdrawals(withdrawlsToRender);
  }, []);

  function createData(Years, Age, Amount) {
    return { Years, Age, Amount };
  }
  const confirmHandler = (form, yearsData, name) => {
    const withdrawalsArray = withdrawals.slice();
    let updatedWithDrawals = withdrawalsArray;
    let rowIndex = +name.split('-')[1];
    let totalRows = LIMIT - START_AGE + 1;
    let applyToValue = +form['apply']?.value > 0 ? +form['apply']?.value : 1;
    let applyLimit = totalRows >= applyToValue ? applyToValue - 1 : totalRows - rowIndex;
    for (let i = 0; i <= applyLimit; i++) {
      updatedWithDrawals[rowIndex + i - 1] = {
        Yr: (+name.split('-')[1] + i).toString(),
        Amount: +form[name]?.value,
      };
    }
    setWithdrawals(updatedWithDrawals);
    form.reset();
  };
  const generateRows = () => {
    const rows = [];
    let yearsData = 1;
    for (let age = START_AGE; age <= LIMIT; age++) {
      const name = `Amount-${yearsData}`;
      rows.push(
        createData(
          yearsData,
          age,
          <CustomInputFieldWithModal
            defaultValue={withdrawals[+name.split('-')[1] - 1]?.['Amount'] ?? ''}
            handleConfirmValue={(form) => confirmHandler(form, yearsData, name)}
            name={name}
          />
        )
      );
      yearsData++;
    }
    return rows;
  };
  const getClientInfo = () => {
    const currentVersion = data.createdVersions[0];
    delete currentVersion.illustrationData.client;
    currentVersion.illustrationData = JSON.stringify({
      ...currentVersion.illustrationData,
      withDrawls: withdrawals?.filter((withdrawl) => withdrawl !== null),
    });
    data.createdVersions = [currentVersion];
    delete data.createdVersions[0]?.id;
    return data;
  };
  useImperativeHandle(ref, () => {
    return {
      getClientInfo: () => getClientInfo(),
    };
  }, [withdrawals]);

  return (
    <div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Years</TableCell>
              <TableCell align="center">Age</TableCell>
              <TableCell align="center">Amount</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {generateRows().map((row) => (
              <TableRow key={row.Years} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                <TableCell component="th" scope="row">
                  {row.Years}
                </TableCell>
                <TableCell align="center">{row.Age}</TableCell>
                <TableCell width={500} align="center">
                  {row.Amount}{' '}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
});
export default Withdraw;
